import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';

export default class SyncStore {
    version = '1.0';
    calendar = {};
    observed = {};
    constructor() {
        makeObservable(this, {
            observed: observable,
        });

        withActions(this, actions);
    }
}

export function useSyncStore () {
    const { store } = useStores();
    return store.syncStore;
}
